var _defs, _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.31 5.709H15.284a5.675 5.675 0 00-5.675 5.675v11.374M33.461 22.759v-9.84M26.31 5.812l7.111 7.11M25.426 7.045v6.733h7.111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.89,
    cy: 13.54,
    r: 1.445
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.178 29.074H14.891M21.535 22.43v13.287"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.178 29.074H14.891M21.535 22.43v13.287"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateStatement);
export default __webpack_public_path__ + "static/media/createStatement.d58504e479d19d3f723bc233ba4fa02f.svg";
export { ForwardRef as ReactComponent };